'use strict';

var kleber = require('./kleberCommon.js');
var shippingBaseObj = require('base/checkout/shipping');
var selectIntoInput = require('../components/transformSelectIntoInput');

var PAGETYPE_ADDRESSBOOK = 'addressbook';
var PAGETYPE_CHECKOUT = 'checkout';
var FORM_ADDRESSBOOK = 'addressbook';
var FORM_SHIPPING = 'shipping';
var FORM_BILLING = 'billing';

var SEARCH_ADDRESS_FIELD_ID = {
    addressbook: '#shippingAddressSearch',
    shipping: '#shippingAddressSearch',
    billing: '#billingAddressSearch'
};

var COUNTRY_FIELD_ID = {
    addressbook: '#shippingCountry',
    shipping: '#shippingCountry',
    billing: '#billingCountry'
};


var KLEBER_METHODS = {
    AU: {
        searchAddress: 'DataTools.Capture.Address.Predictive.AuPaf.SearchAddress',
        retrieveAddress: 'DataTools.Capture.Address.Predictive.AuPaf.RetrieveAddress'
    },
    GB: {
        searchAddress: 'DataTools.Capture.Address.Predictive.UkPaf.SearchAddress',
        retrieveAddress: 'DataTools.Capture.Address.Predictive.UkPaf.RetrieveAddress'
    },
    CA: {
        searchAddress: 'DataTools.Capture.Address.Predictive.CaPaf.SearchAddress',
        retrieveAddress: 'DataTools.Capture.Address.Predictive.CaPaf.RetrieveAddress'
    },
    NZ: {
        searchAddress: 'DataTools.Capture.Address.Predictive.NzPaf.SearchAddress',
        retrieveAddress: 'DataTools.Capture.Address.Predictive.NzPaf.RetrieveAddress'
    },
    INT: {
        searchAddress: 'DataTools.Capture.Address.Predictive.IntPca.SearchAddress',
        retrieveAddress: 'DataTools.Capture.Address.Predictive.IntPca.RetrieveAddress'
    }
};

var kleberConfigs = window.kleberConfigs;
var defaultSiteCountry = kleberConfigs.getCurrentSite;
var isProductionInstance = kleberConfigs.isProductionInstance;
var KLEBER_REQUEST_URL;

if (isProductionInstance) {
    KLEBER_REQUEST_URL = 'https://kleber.datatoolscloud.net.au/KleberWebService/DtKleberService.svc/ProcessQueryStringRequest';
} else {
    KLEBER_REQUEST_URL = 'https://kleber-devuat.datatoolscloud.net.au/KleberWebService/DtKleberService.svc/ProcessQueryStringRequest';
}

/**
 * Returns minimum search term length
 *
 * @returns {int} Min search term length
 */
function getMinSearchTermLength() {
    return parseInt(kleberConfigs.kleberMinSearchTermLength); //eslint-disable-line
}

/**
  * To return Default site country value
  * @param {*} countryElement selected country
  * @returns {string} Country Value
 */
function setCountryValue(countryElement) {
    var countryCode;
    if ((defaultSiteCountry === 'bardot_au') || (defaultSiteCountry === 'bardot_junior')) {
        countryCode = 'AU';
    } else if ((defaultSiteCountry === 'bardot_us') || (defaultSiteCountry === 'bardot_junior_us')) {
        countryCode = 'US';
    }

    countryElement.val(countryCode);
    return countryCode;
}

/**
  * Populates state field
  * @param {*} countryField - country field Html element ID
  * @param {*} stateField - State field HTML Element ID
  * @param {*} stateFieldValue - state code to be populated
 */
function populateStateField(countryField, stateField, stateFieldValue) {
    if (window.stateCountries[$(countryField).val()]) {
        var customSelectElement = $(stateField).parent().find('.selectbox-options').find("[option-value='" + stateFieldValue + "']");
        if (customSelectElement.length > 0) {
            customSelectElement.trigger('click');
        } else {
            $(stateField).val(stateFieldValue);
        }
    } else {
        $(stateField).val(stateFieldValue);
    }
}

/**
 * Returns current page type
 *
 * @returns {string} Page type
 */
function getKleberPageType() {
    return kleberConfigs.kleberPageType;
}

/**
 * This function returns the SFCC address field to Kleber address component mapping
 * based on country selected
 *
 * @param {*} countryCode - Country code
 * @returns {Object} - JSON with mapping details
 */
 function getAddressFormFieldsToComponentMappingsForCountry(countryCode) {
    if (countryCode in kleberConfigs.kleberAddressFieldAddressComponentMapping) {
        return Object.assign({}, kleberConfigs.kleberAddressFieldAddressComponentMapping[countryCode]);
    }
    return Object.assign({}, kleberConfigs.kleberAddressFieldAddressComponentMapping.default);
}


/**
 * Common function to parse the KleberRetrieve service response for handling address form
 *
 * @param {*} kleberResponse - Response object
 * @param {*} countryCode - Country Code
 * @returns {Object} - JSON object holding values to be populated in the address form fields
 */
 function parseKleberRetrieveAddressResponse(kleberResponse, countryCode) {
    var sfccAddressFormFieldValues = {};

    var kleberAddress = '';
    if (kleberResponse && kleberResponse.length > 0) {
        // In case of China country address search, Kleber appears to return 2 responses
        // In such cases the first address entered is in Chinese and the 2nd address is in English
        // The english version of the address is used
        kleberAddress = kleberResponse.pop();
    }

    // Get the JSON with the SFCC address field - Kleber address field mappings
    var addressFormFieldsToComponentMappings = getAddressFormFieldsToComponentMappingsForCountry(countryCode);

    // Clone the mappings object which shall hold the final set of values to be populated in the SFCC form
    sfccAddressFormFieldValues = Object.assign({}, addressFormFieldsToComponentMappings);

    // Loop through the Kleber address fields provided in the Kleber response
    var kleberAddressFields = Object.keys(kleberAddress);
    kleberAddressFields.forEach((kleberAddressField) => {
        var kleberAddressFieldRegExp = new RegExp('{{' + kleberAddressField + '}}', 'g');

        // Loop through the SFCC address form fields in the JSON
        let sfccAddressFormFields = Object.keys(addressFormFieldsToComponentMappings);
        sfccAddressFormFields.forEach((sfccAddressFormField) => { //eslint-disable-line
            var addressFieldValuePattern = addressFormFieldsToComponentMappings[sfccAddressFormField];

            // Check if the Kleber address field is present in the SFCC form field value pattern
            if (kleberAddressFieldRegExp.test(addressFieldValuePattern)) {
                // Update the value of the SFCC address field with the value returned by Kleber
                var addressFormFieldValue = sfccAddressFormFieldValues[sfccAddressFormField];
                sfccAddressFormFieldValues[sfccAddressFormField] = addressFormFieldValue.replace(kleberAddressFieldRegExp, kleberAddress[kleberAddressField]);
                return false;
            }
        });
    });


    // Remove any non mapped address components from final address form field values
    let sfccAddressFormFields = Object.keys(sfccAddressFormFieldValues);
    var nonMappedRegex = new RegExp('{{[^}}]*}},*', 'g');
    var trailingCommaAtEndRegex = new RegExp(', $');
    var trailingCommaAtStartRegex = new RegExp('^,');
    sfccAddressFormFields.forEach(function (sfccAddressFormField) {
        var fieldValue = sfccAddressFormFieldValues[sfccAddressFormField];
        fieldValue = fieldValue.replace(nonMappedRegex, '');
        fieldValue = fieldValue.replace(trailingCommaAtEndRegex, '');
        fieldValue = fieldValue.replace(trailingCommaAtStartRegex, '');
        sfccAddressFormFieldValues[sfccAddressFormField] = fieldValue;
    });

    return sfccAddressFormFieldValues;
}

/**
 * Get Kleber Request Method Name regarding of Country
 * @private
 * @function
 * @param {string} countryCode Country Code
 * @param {string} methodName Method Name - searchAddress OR retrieveAddress
 * @return {string} Kleber request method name
 */
 function getKleberMethod(countryCode, methodName) {
    var upperCountryCode = countryCode.toUpperCase() || '';

    if (upperCountryCode in KLEBER_METHODS) {
        return KLEBER_METHODS[upperCountryCode][methodName];
    }
    return KLEBER_METHODS['INT'][methodName]; //eslint-disable-line
}

/**
 * This function retrieves the Kleber address using the Kleber record selected by the customer from the search suggestions.
 * When the promise for the temporary access key is resolved,the Kleber Retrieve API is invoked.
 * Once we receive the response, the address form is populated with the responses
 *
 * @param {*} item - Selected Kleber record id
 * @param {*} countryCode - Country code selected
 * @param {*} populateAddressFormFn - Function to populate address form
 */
function kleberRetrieveAddress(item, countryCode, populateAddressFormFn) {
    kleber.getTemporaryAccessKey().then((kleberTemporaryAccessKey) => {
        $.ajax({
            url: KLEBER_REQUEST_URL,
            dataType: 'jsonp',
            crossDomain: true,
            data: {
                Method: getKleberMethod(countryCode, 'retrieveAddress'),
                RecordId: item.RecordId,
                RequestKey: kleberTemporaryAccessKey,
                DepartmentCode: countryCode.toUpperCase(),
                OutputFormat: 'json'
            },
            success: function (data) {
                if (data.DtResponse && data.DtResponse.Result && data.DtResponse.Result.length > 0) {
                    var addressFieldValues = parseKleberRetrieveAddressResponse(data.DtResponse.Result, countryCode);
                    // Populate address form with response from Kleber
                    populateAddressFormFn(addressFieldValues);
                } else {
                    console.log('Unable to retrieve results'); //eslint-disable-line
                    console.log(data); //eslint-disable-line
                }
            }
        });
    });
}

/**
 * This function sets the results returned by Kleber Search service for the address
 * entered by the customer within sessionStorage. This helps reduce the number of API calls to Kleber
 *
 * @param {*} countryCode - Selected country code
 * @param {*} searchTerm - Search term entered by customer
 * @param {*} results - Kleber results
 */
 function setKleberSearchResultsInSessionCache(countryCode, searchTerm, results) {
    try {
        let data = sessionStorage.getItem('kleberSearchResults');
        let kleberSearchResults = data ? JSON.parse(data) : {};
        if (!(countryCode in kleberSearchResults)) {
            kleberSearchResults[countryCode] = {};
        }
        kleberSearchResults[countryCode][searchTerm] = results;
        sessionStorage.setItem('kleberSearchResults', JSON.stringify(kleberSearchResults));
    } catch (e) {
        // Session storage is not supported
    }
}

/**
 * This function gets the results returned by Kleber Search service within sessionStorage for the address entered by the customer.
 * This helps reduce the number of API calls to Kleber
 *
 * @param {*} countryCode - Selected country code
 * @param {*} searchTerm - Search term entered by customer
 * @returns {Object} - Kleber search results
 */
 function getKleberSearchResultsFromSessionCache(countryCode, searchTerm) {
    try {
        let data = sessionStorage.getItem('kleberSearchResults');
        let kleberSearchResults = data ? JSON.parse(data) : {};
        if (countryCode in kleberSearchResults && searchTerm in kleberSearchResults[countryCode]) {
            return kleberSearchResults[countryCode][searchTerm];
        }
    } catch (e) {
        // Session storage is not supported
    }
    return null;
}

/**
 * This function retrieves the Kleber address suggestions using the Kleber Search service and the search term entered by the customer from the search suggestions.
 * The logic looks up the sessionStorage to check if Kleber results had been previously stored for the search term and country code combination.
 * If not then, the Kleber temporary key is retrieved/generated via a promise and when the promise is resolved, the Kleber Search API is invoked.
 * Once we receive the response, the address suggestions are displayed to the customer
 *
 * @param {*} searchTerm - Search term entered by customer
 * @param {*} countryCode  - Selected country code
 * @param {*} responseCallbackFn - Response call back function for Jquery autocomplete
 */
function kleberAddressSearch(searchTerm, countryCode, responseCallbackFn) {
    var resultsFromCache = getKleberSearchResultsFromSessionCache(countryCode, searchTerm);
    if (resultsFromCache) {
        responseCallbackFn(resultsFromCache);
        return;
    }
    kleber.getTemporaryAccessKey().then((kleberTemporaryAccessKey) => {
        $.ajax({
            url: KLEBER_REQUEST_URL,
            dataType: 'jsonp',
            type: 'GET',
            contentType: 'application/json; charset=utf-8',
            data: {
                Method: getKleberMethod(countryCode, 'searchAddress'),
                AddressLine: searchTerm,
                ResultLimit: 10,
                SearchCountryCode: countryCode.toUpperCase(),
                RequestId: ' ',
                RequestKey: kleberTemporaryAccessKey,
                DepartmentCode: countryCode.toUpperCase(),
                OutputFormat: 'json'
            },
            success: function (data) {
                if (data.DtResponse.Result.length === 0) {
                    console.log('No results returned'); //eslint-disable-line
                    setKleberSearchResultsInSessionCache(countryCode, searchTerm, []);
                    return;
                }
                var results = $.map(data.DtResponse.Result, function (item) {
                    var addressLine = '';
                    var value;

                    if (Object.prototype.hasOwnProperty.call(item, 'AddressLine')) {
                        addressLine = 'AddressLine';
                    } else if (Object.prototype.hasOwnProperty.call(item, 'DisplayLine')) {
                        addressLine = 'DisplayLine';
                    }

                    value = item[addressLine];

                    if (Object.prototype.hasOwnProperty.call(item, 'Locality')
                        && item.Locality) {
                        value += ', ' + item.Locality;
                    }

                    if (Object.prototype.hasOwnProperty.call(item, 'Postcode')
                        && item.Postcode) {
                        value += ', ' + item.Postcode;
                    }

                    if (Object.prototype.hasOwnProperty.call(item, 'State')
                        && item.State) {
                        value += ', ' + item.State;
                    }

                    return {
                        label: value,
                        value: value,
                        Output: value,
                        RecordId: item.RecordId,
                        AddressLine: value
                    };
                });

                setKleberSearchResultsInSessionCache(countryCode, searchTerm, results);

                responseCallbackFn(results);
            }
        });
    });
}

/**
 * Checks if address search is enabled for address book
 *
 * @returns {boolean} - Address search enabled for address book
 */
function isEnabledForAddressBook() {
    return 'isKleberAddressSearchEnabled' in kleberConfigs && kleberConfigs.isKleberAddressSearchEnabled;
}

/**
 * Checks if address search is enabled for checkout shipping
 *
 * @returns {boolean} - Address search enabled for checkout shipping
 */
function isEnabledForShippingAddress() {
    return 'isKleberAddressSearchEnabledForShipping' in kleberConfigs && kleberConfigs.isKleberAddressSearchEnabledForShipping;
}

/**
 * Checks if address search is enabled for checkout billing
 * @returns {boolean} - Address search enabled for checkout billing
 */
function isEnabledForBillingAddress() {
    return 'isKleberAddressSearchEnabledForBilling' in kleberConfigs && kleberConfigs.isKleberAddressSearchEnabledForBilling;
}

/**
 *
 * @param {string} className className
 * @param {Object} addressFieldValues addressFieldValues
 * @param {string} countrySelected country selected
 * @returns {string} container
 */
function appendKleberAddressContainer(className, addressFieldValues, countrySelected) {
    var addressHtmlData = '<div class="address-suggestion-selection">'
    + '<span class="icon icon-icon-tick-success"></span>'
    + '<div class="address-section">'
    + '<div class="' + className + ' address-suggestion-address1">' + addressFieldValues.address1 + '</div>'
    + '<div class="' + className + ' address-suggestion-address2 d-none">' + addressFieldValues.address2 + '</div>'
    + '<div class="' + className + ' address-suggestion-state d-none">' + addressFieldValues.stateCode + '</div>'
    + '<div class="' + className + ' address-suggestion-city">' + addressFieldValues.city + '</div>'
    + '<div class="' + className + ' address-suggestion-postcode">' + addressFieldValues.postalCode + '</div>'
    + '<div class="' + className + ' address-suggestion-country">' + countrySelected.toUpperCase() + '</div>'
    + '</div>'
    + '</div>';
    return addressHtmlData;
}

/**
 * Clears address book form
 */
function clearAddressBookForm() {
    $('#shippingAddressOne').val('');
    $('#shippingAddressTwo').val('');
    $('#shippingState').val('');
    $('#shippingAddressCity').val('');
    $('#shippingZipCode').val('');
    $('.addressbook-address-suggestion-selection-container').empty();

    // clears addressbook error fields
    $('#shippingAddressOne').removeClass('is-invalid');
    $('#shippingAddressCity').removeClass('is-invalid');
    $('#shippingZipCode').removeClass('is-invalid');
    var shippingStateSelect = $('select[id="shippingState"]');
    var shippingStateInput = $('input[id="shippingState"]');
    var invalidFeedback;
    
    if (shippingStateSelect.length > 0) {
        invalidFeedback = shippingStateSelect.parent().find('.invalid-feedback');
        var customSelectBox = shippingStateSelect.parent().find('.custom-selectbox ');
        shippingStateSelect.removeClass('invalid-state');
        customSelectBox.css('border-color', '#9e9e9e');
        invalidFeedback.css('display', 'none');
        invalidFeedback.text('');
    }
    if (shippingStateInput.length > 0) {
        invalidFeedback = shippingStateInput.parent().find('.invalid-feedback');
        shippingStateInput.removeClass('invalid-state');
        invalidFeedback.css('display', 'none');
        invalidFeedback.text('');
    }
}

/**
 * Populates address book form
 *
 * @param {*} addressFieldValues - JSON holding values to be populated in the form
 */
function populateAddressBookForm(addressFieldValues) {
    if (addressFieldValues) {
    // Clear the form fields
    clearAddressBookForm();
    var countryCode;
    var countrySelectedVal = $('select#shippingCountry option:selected').val();
    var className = 'addressbook-address-suggestion';

    if (countrySelectedVal === '') {
        if ((defaultSiteCountry === 'bardot_au') || (defaultSiteCountry === 'bardot_junior')) {
            countryCode = 'AU';
        } else if ((defaultSiteCountry === 'bardot_us') || (defaultSiteCountry === 'bardot_junior_us')) {
            countryCode = 'US';
        }
        selectIntoInput.transformSelectIntoInput('#shippingState', 'select', countryCode);
        var selectedCountry = $('select#shippingCountry');
        countrySelectedVal = setCountryValue(selectedCountry);
    }

    // Update the form fields
    $('#shippingAddressOne').val(addressFieldValues.address1);
    $('#shippingAddressTwo').val(addressFieldValues.address2);
    if (addressFieldValues.stateCode) {
        populateStateField('#shippingCountry', '#shippingState', addressFieldValues.stateCode);
    } else {
        populateStateField('#shippingCountry', '#shippingState', addressFieldValues.city);
    }
    $('#shippingAddressCity').val(addressFieldValues.city);
    $('#shippingZipCode').val(addressFieldValues.postalCode);

    var appendFunction = appendKleberAddressContainer(className, addressFieldValues, countrySelectedVal);


    $('.addressbook-address-suggestion-selection-container').empty();
    $('.address-suggestion-selection-container').removeClass('hide-trigger');
    $('.addressbook-address-suggestion-selection-container').html(appendFunction);

    $('input#shippingAddressOne').attr('data-value', addressFieldValues.address1);
    $('input#shippingAddressTwo').attr('data-value', addressFieldValues.address2);
    $('select#shippingState').attr('data-value', addressFieldValues.stateCode);
    $('input#shippingAddressCity').attr('data-value', addressFieldValues.city);
    $('input#shippingZipCode').attr('data-value', addressFieldValues.postalCode);

    $('#shippingAddressSearch').val('');
    }
}

/**
 * Clears shipping address form
 */
function clearShippingAddressForm() {
    $('#shippingAddressOne').val('');
    $('#shippingAddressTwo').val('');
    $('#shippingState').val('');
    $('#shippingAddressCity').val('');
    $('#shippingZipCode').val('');
    $('.shipping-address-suggestion-selection-container').empty();

    // clears shipping form error fields
    $('.shippingAddressOne').removeClass('is-invalid');
    $('.shippingAddressCity').removeClass('is-invalid');
    $('.shippingZipCode').removeClass('is-invalid');
    var shippingStateSelect = $('select[id="shippingState"]');
    var shippingStateInput = $('input[id="shippingState"]');

    if (shippingStateSelect.length > 0) {
        var customSelectBox = shippingStateSelect.parent().find('.custom-selectbox ');
        shippingStateSelect.removeClass('is-invalid');
        customSelectBox.css('border-color', '#9e9e9e');
    }

    if (shippingStateInput.length > 0) {
        shippingStateInput.removeClass('is-invalid');
    }
}

/**
 * Populates shipping address form
 *
 * @param {*} addressFieldValues - JSON holding values to be populated in the form
 */
function populateShippingAddressForm(addressFieldValues) {
    if (addressFieldValues) {
    // Clear the form fields
    clearShippingAddressForm();
    var countryCode;
    var countrySelectedVal = $('select#shippingCountry option:selected').val();
    var className = 'shipping-address-suggestion';

    if (countrySelectedVal === '') {
        if ((defaultSiteCountry === 'bardot_au') || (defaultSiteCountry === 'bardot_junior')) {
            countryCode = 'AU';
        } else if ((defaultSiteCountry === 'bardot_us') || (defaultSiteCountry === 'bardot_junior_us')) {
            countryCode = 'US';
        }
        selectIntoInput.transformSelectIntoInput('#shippingState', 'select', countryCode);

        var selectedCountry = $('select#shippingCountry');
        countrySelectedVal = setCountryValue(selectedCountry);
        var shippingForm = $('.shipping-form');
        if (shippingBaseObj.methods && shippingBaseObj.methods.updateShippingMethodList) {
            shippingBaseObj.methods.updateShippingMethodList(shippingForm);
        } else {
            shippingBaseObj.methods.updateShippingMethodList(shippingForm);
        }
    }


    // Update the form fields
    $('#shippingAddressOne').val(addressFieldValues.address1);
    $('#shippingAddressTwo').val(addressFieldValues.address2);
    if (addressFieldValues.stateCode) {
        populateStateField('#shippingCountry', '#shippingState', addressFieldValues.stateCode);
    } else {
        populateStateField('#shippingCountry', '#shippingState', addressFieldValues.city);
    }
    $('#shippingAddressCity').val(addressFieldValues.city);
    $('#shippingZipCode').val(addressFieldValues.postalCode);
    var appendFunction = appendKleberAddressContainer(className, addressFieldValues, countrySelectedVal);

    $('.shipping-address-suggestion-selection-container').empty();
    $('.address-suggestion-selection-container').removeClass('hide-trigger');
    $('.shipping-address-suggestion-selection-container').html(appendFunction);

    $('input#shippingAddressOne').attr('data-value', addressFieldValues.address1);
    $('input#shippingAddressTwo').attr('data-value', addressFieldValues.address2);
    $('select#shippingState').attr('data-value', addressFieldValues.stateCode);
    $('input#shippingAddressCity').attr('data-value', addressFieldValues.city);
    $('input#shippingZipCode').attr('data-value', addressFieldValues.postalCode);
    window.sessionStorage.setItem('invalidAddress', 'false');

    $('#shippingAddressSearch').val('');
    }
}

/**
 * Clears billing address form
 */
function clearBillingAddressForm() {
    $('#billingAddressOne').val('');
    $('#billingAddressTwo').val('');
    $('#billingState').val('');
    $('#billingAddressCity').val('');
    $('#billingZipCode').val('');
    $('.billing-address-suggestion-selection-container').empty();

    // clear billing form error fields
    $('.billingAddressOne').removeClass('is-invalid');
    $('.billingAddressCity').removeClass('is-invalid');
    $('.billingZipCode').removeClass('is-invalid');
    var billingStateSelect = $('select[id="billingState"]');
    var billingStateInput = $('input[id="billingState"]');

    if (billingStateSelect.length > 0) {
        var customSelectBox = billingStateSelect.parent().find('.custom-selectbox ');
        billingStateSelect.removeClass('is-invalid');
        customSelectBox.css('border-color', '#9e9e9e');
    }

    if (billingStateInput.length > 0) {
        billingStateInput.removeClass('is-invalid');
    }
}

/**
 * Populates billing address form
 *
 * @param {*} addressFieldValues - JSON holding values to be populated in the form
 */
function populateBillingAddressForm(addressFieldValues) {
    if (addressFieldValues) {
    // Clear the form fields
    clearBillingAddressForm();
    var countrySelectedVal = $('select#billingCountry option:selected').val();
    var countryCode;
    var className = 'billing-address-suggestion';

    if (countrySelectedVal === '') {
        if ((defaultSiteCountry === 'bardot_au') || (defaultSiteCountry === 'bardot_junior')) {
            countryCode = 'AU';
        } else if ((defaultSiteCountry === 'bardot_us') || (defaultSiteCountry === 'bardot_junior_us')) {
            countryCode = 'US';
        }
        selectIntoInput.transformSelectIntoInput('#billingState', 'select', countryCode);
        var selectedCountry = $('select#billingCountry');
        countrySelectedVal = setCountryValue(selectedCountry);
    }

    // Update the form fields
    $('#billingAddressOne').val(addressFieldValues.address1);
    $('#billingAddressTwo').val(addressFieldValues.address2);
    if (addressFieldValues.stateCode) {
        populateStateField('#billingCountry', '#billingState', addressFieldValues.stateCode);
    } else {
        populateStateField('#billingCountry', '#billingState', addressFieldValues.city);
    }
    $('#billingAddressCity').val(addressFieldValues.city);
    $('#billingZipCode').val(addressFieldValues.postalCode);

    // Add a new box that display the selected address details.

    var appendFunction = appendKleberAddressContainer(className, addressFieldValues, countrySelectedVal);
    
    $('.billing-address-suggestion-selection-container').empty();
    $('.address-suggestion-selection-container').removeClass('hide-trigger');
    $('.billing-address-suggestion-selection-container').html(appendFunction);

    $('#billingAddressSearch').val('');
    }
}

var POPULATE_ADDRESS_FORM_FN = {
    addressbook: populateAddressBookForm,
    shipping: populateShippingAddressForm,
    billing: populateBillingAddressForm
};

var CLEAR_ADDRESS_FORM_FN = {
    addressbook: clearAddressBookForm,
    shipping: clearShippingAddressForm,
    billing: clearBillingAddressForm
};


/**
 * Initialise Jquery autocomplete functionality on address search field for
 * - Address book
 * - Checkout shipping
 * - Checkout billing
 * Refer: https://api.jqueryui.com/autocomplete
 *
 * @param {*} formType - Type of form (shipping, billing or addressbook)
 */
 function initAddressSearch(formType) {
    var $addressSearchField = $(SEARCH_ADDRESS_FIELD_ID[formType]);
    var $countryField = $(COUNTRY_FIELD_ID[formType]);
    var populateAddressFormFn = POPULATE_ADDRESS_FORM_FN[formType];

    $addressSearchField.autocomplete({
        delay: 300,
        minLength: getMinSearchTermLength(),
        classes: {
            'ui-autocomplete': 'kleber-autocomplete'
        },
        source: function (request, responseCallBackFn) {
            if (request.term) {
                var countryCode = $countryField.val();
                if (!countryCode) {
                    if ((defaultSiteCountry === 'bardot_au') || (defaultSiteCountry === 'bardot_junior')) {
                        countryCode = 'AU';
                    } else if ((defaultSiteCountry === 'bardot_us') || (defaultSiteCountry === 'bardot_junior_us')) {
                        countryCode = 'US';
                    }
                }
                kleberAddressSearch(request.term, countryCode, responseCallBackFn);
                var width;
                if (formType === 'billing') {
                    width = $('.address-search').width();
                } else {
                    width = $('.addressbook-addresssearch').width();
                }
                $('.kleber-autocomplete').css('max-width', width);
            }
        },
        select: function (event, ui) {
            if (ui.item.RecordId) {
                var countryCode = $countryField.val();
                if (!countryCode) {
                    if ((defaultSiteCountry === 'bardot_au') || (defaultSiteCountry === 'bardot_junior')) {
                        countryCode = 'AU';
                    } else if ((defaultSiteCountry === 'bardot_us') || (defaultSiteCountry === 'bardot_junior_us')) {
                        countryCode = 'US';
                    }
                }
                kleberRetrieveAddress(ui.item, countryCode, populateAddressFormFn);
            }
        }
    });
}


/**
 * Initialise address form related events for
 * - Address book
 * - Checkout shipping
 * - Checkout billing
 * @param {*} formType - Type of form (shipping, billing or addressbook)
 */
function initAddressFormCommonEvents(formType) {
    var $addressSearchField = $(SEARCH_ADDRESS_FIELD_ID[formType]);
    var $countryField = $(COUNTRY_FIELD_ID[formType]);
    // var isCountrySelectedInFormFn = COUNTRY_SELECTED_FN[formType];
    var clearAddressFormFn = CLEAR_ADDRESS_FORM_FN[formType];

    /**
     * On page load, a country may not be selected and customers may try to enter to search for an address. This results in the Country field being highlighted with a message forcing the
     * customer to select a country.
     * Once the customer has selected a country, we enable the autocomplete functionality and remove any error message.  This event has been registered to handle this.
     */
     $countryField.on('change', function (e, data) { //eslint-disable-line
        // Clear address form fields
        if (!(data && 'skipClearAddressForm' in data && data.skipClearAddressForm)) {
            clearAddressFormFn();
        }

        // Enable autocomplete if country is selected
        $addressSearchField.autocomplete('option', 'disabled', false);

        // Clear any errors against country field
        $countryField.removeClass('is-invalid');
    });

    /**
     * This custom event invalidates an empty Country field with a message forcing the customer to select a country before searching for an address.
     * This event has been registered to handle this. This is invoked during the keydown event of the search address field
     */
     $addressSearchField.on('custom:kleberFocusCountryField', function (e) { //eslint-disable-line
        $countryField.trigger('invalid', true);
        // TODO: Add a scroll event
    });
}

module.exports = {
    init: function () {
        if (getKleberPageType() === PAGETYPE_ADDRESSBOOK && isEnabledForAddressBook()) {
            initAddressSearch(FORM_ADDRESSBOOK);
            initAddressFormCommonEvents(FORM_ADDRESSBOOK);
        } else if (getKleberPageType() === PAGETYPE_CHECKOUT) {
            if (isEnabledForShippingAddress()) {
                initAddressSearch(FORM_SHIPPING);
                initAddressFormCommonEvents(FORM_SHIPPING);
            }

            if (isEnabledForBillingAddress()) {
                initAddressSearch(FORM_BILLING);
                initAddressFormCommonEvents(FORM_BILLING);
            }
        }
    },
    populateShippingAddressForm: populateShippingAddressForm,
    populateAddressBookForm: populateAddressBookForm,
    parseKleberRetrieveAddressResponse: parseKleberRetrieveAddressResponse
};

